import React, { useState, useEffect } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const ControlHologramasSection = ({
  hologramaRecords,
  terminadoRecords,
  isFormOpen,
  setIsFormOpen,
  idEnvasadoTerminado,
  setIdEnvasadoTerminado,
  fechaMovimiento,
  setFechaMovimiento,
  marca,
  setMarca,
  loteEnvasado,
  setLoteEnvasado,
  capacidad,
  setCapacidad,
  invInicialRango,
  setInvInicialRango,
  invInicialCant,
  setInvInicialCant,
  entradaRango,
  setEntradaRango,
  entradaCant,
  setEntradaCant,
  salidaRango,
  setSalidaRango,
  salidaCant,
  setSalidaCant,
  invFinalRango,
  setInvFinalRango,
  invFinalCant,
  setInvFinalCant,
  mermasRango,
  setMermasRango,
  mermasCant,
  setMermasCant,
  observaciones,
  setObservaciones,
  handleSaveHologramas
}) => {

  // Auto-fill fields if Finished Bottling record is selected
  useEffect(() => {
    if (idEnvasadoTerminado && idEnvasadoTerminado !== "manual") {
      const selected = terminadoRecords.find(r => r.id === idEnvasadoTerminado);
      if (selected) {
        setMarca(selected.marca);
        setLoteEnvasado(selected.loteEnvasado);
        setCapacidad(selected.capacidad);
      }
    }
  }, [idEnvasadoTerminado, terminadoRecords, setMarca, setLoteEnvasado, setCapacidad]);

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Control del Inventario de Hologramas (Sección V)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro de Hologramas</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="6" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Relación de Envasado</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Inventario Inicial</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Entradas</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Salidas</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Inventario Final</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Mermas</th>
                <th colSpan="3" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                <th>Ref. Envasado</th>
                <th>Fecha Mov.</th>
                <th>Marca</th>
                <th>Lote Envasado</th>
                <th>Capacidad</th>

                {/* Inicial */}
                <th>Rango</th>
                <th>Cant.</th>

                {/* Entradas */}
                <th>Rango</th>
                <th>Cant.</th>

                {/* Salidas */}
                <th>Rango</th>
                <th>Cant.</th>

                {/* Final */}
                <th>Rango</th>
                <th>Cant.</th>

                {/* Mermas */}
                <th>Rango</th>
                <th>Cant.</th>

                {/* Cierre */}
                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {hologramaRecords.map((rec, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 700, color: "var(--copper)" }}>{rec.idEnvasadoTerminado}</td>
                  <td>{rec.fechaMovimiento}</td>
                  <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                  <td>{rec.loteEnvasado}</td>
                  <td>{rec.capacidad}</td>

                  <td style={{ fontSize: "12px" }}>{rec.invInicialRango}</td>
                  <td style={{ fontWeight: 600 }}>{rec.invInicialCant}</td>

                  <td style={{ fontSize: "12px", color: "var(--agave-green)" }}>{rec.entradaRango}</td>
                  <td style={{ fontWeight: 600, color: "var(--agave-green)" }}>{rec.entradaCant}</td>

                  <td style={{ fontSize: "12px", color: "var(--copper)" }}>{rec.salidaRango}</td>
                  <td style={{ fontWeight: 600, color: "var(--copper)" }}>{rec.salidaCant}</td>

                  <td style={{ fontSize: "12px", fontWeight: 700 }}>{rec.invFinalRango}</td>
                  <td style={{ fontWeight: 800 }}>{rec.invFinalCant}</td>

                  <td style={{ fontSize: "12px", color: "var(--status-draft-color)" }}>{rec.mermasRango}</td>
                  <td style={{ color: "var(--status-draft-color)" }}>{rec.mermasCant}</td>

                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nuevo Registro de Inventario de Hologramas - Sección V</h2>
      </div>

      <div className="cards-container-grid">
        {/* ENLAZAR ENVASADO TERMINADO */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Relación de Envasado & Identificación</h2>
              <p>Vincular holograma con lote terminado</p>
            </div>
          </header>

          <div className="custom-input-group">
            <select 
              value={idEnvasadoTerminado} 
              onChange={e => setIdEnvasadoTerminado(e.target.value)}
              className="custom-select-field"
              style={{ padding: "18px 16px 8px 16px" }}
            >
              <option value="manual">Ingreso Manual (Sin lote pre-registrado)</option>
              {terminadoRecords.map(r => (
                <option key={r.id} value={r.id}>
                  {r.id} - Lote: {r.loteEnvasado} ({r.marca} - {r.capacidad})
                </option>
              ))}
            </select>
            <label className="custom-input-label">Enlace Envasado Terminado (ID)</label>
          </div>

          <div className="species-grid" style={{ marginTop: 16 }}>
            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaMovimiento} 
                onChange={e => setFechaMovimiento(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha del Movimiento</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={marca} 
                onChange={e => setMarca(e.target.value)} 
                className="custom-input-field"
                disabled={idEnvasadoTerminado !== "manual"}
              />
              <label className="custom-input-label">Marca Comercial</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={loteEnvasado} 
                onChange={e => setLoteEnvasado(e.target.value)} 
                className="custom-input-field"
                disabled={idEnvasadoTerminado !== "manual"}
              />
              <label className="custom-input-label">Lote de Envasado</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={capacidad} 
                onChange={e => setCapacidad(e.target.value)} 
                className="custom-input-field"
                disabled={idEnvasadoTerminado !== "manual"}
              />
              <label className="custom-input-label">Capacidad de la Botella</label>
            </div>
          </div>
        </section>

        {/* INVENTARIO INICIAL & ENTRADAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ConfirmationNumberIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventario Inicial & Entradas</h2>
              <p>Rangos numéricos correlativos asignados</p>
            </div>
          </header>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--text-color)", marginBottom: "8px" }}>INVENTARIO INICIAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={invInicialRango} 
                onChange={e => setInvInicialRango(e.target.value)} 
                className="custom-input-field" 
                placeholder="Ej. A0001 - A0500"
              />
              <label className="custom-input-label">Rango Inicial</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialCant} 
                onChange={e => setInvInicialCant(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Cantidad Inicial</label>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "20px" }}>ENTRADAS (NUEVA ASIGNACIÓN)</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={entradaRango} 
                onChange={e => setEntradaRango(e.target.value)} 
                className="custom-input-field" 
                placeholder="Ej. B0001 - B1000"
              />
              <label className="custom-input-label">Rango Entrada</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={entradaCant} 
                onChange={e => setEntradaCant(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Cantidad Entrada</label>
            </div>
          </div>
        </section>

        {/* SALIDAS, MERMAS E INVENTARIO FINAL */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <TrendingDownIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Consumo (Salidas), Mermas y Balance Final</h2>
              <p>Control de uso de hologramas y adhesión física en botella</p>
            </div>
          </header>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "24px", marginTop: "12px" }}>
            {/* Column 1: Salidas */}
            <div>
              <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--copper)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginBottom: "16px" }}>
                SALIDAS (APLICADOS)
              </h3>
              <div className="custom-input-group" style={{ marginBottom: 12 }}>
                <input 
                  type="text" 
                  value={salidaRango} 
                  onChange={e => setSalidaRango(e.target.value)} 
                  className="custom-input-field" 
                  placeholder="Ej. A0001 - A0450"
                />
                <label className="custom-input-label">Rango Consumido</label>
              </div>

              <div className="custom-input-group">
                <input 
                  type="number" 
                  value={salidaCant} 
                  onChange={e => setSalidaCant(e.target.value)} 
                  className="custom-input-field" 
                />
                <label className="custom-input-label">Cantidad Consumida</label>
              </div>
            </div>

            {/* Column 2: Mermas */}
            <div>
              <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--status-draft-color)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginBottom: "16px" }}>
                MERMAS (DAÑADOS)
              </h3>
              <div className="custom-input-group" style={{ marginBottom: 12 }}>
                <input 
                  type="text" 
                  value={mermasRango} 
                  onChange={e => setMermasRango(e.target.value)} 
                  className="custom-input-field" 
                  placeholder="Ej. A0451 - A0453"
                />
                <label className="custom-input-label">Rango Mermas</label>
              </div>

              <div className="custom-input-group">
                <input 
                  type="number" 
                  value={mermasCant} 
                  onChange={e => setMermasCant(e.target.value)} 
                  className="custom-input-field" 
                />
                <label className="custom-input-label">Cantidad Mermada</label>
              </div>
            </div>

            {/* Column 3: Inventario Final */}
            <div>
              <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginBottom: "16px" }}>
                INVENTARIO FINAL
              </h3>
              <div className="custom-input-group" style={{ marginBottom: 12 }}>
                <input 
                  type="text" 
                  value={invFinalRango} 
                  onChange={e => setInvFinalRango(e.target.value)} 
                  className="custom-input-field" 
                  placeholder="Ej. A0454 - A0500"
                />
                <label className="custom-input-label">Rango Final</label>
              </div>

              <div className="custom-input-group">
                <input 
                  type="number" 
                  value={invFinalCant} 
                  onChange={e => setInvFinalCant(e.target.value)} 
                  className="custom-input-field" 
                />
                <label className="custom-input-label">Cantidad Final</label>
              </div>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 24 }}>
            <textarea 
              value={observaciones} 
              onChange={e => setObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Ej. Hologramas dañados en la aplicación del lote T-ENV-01. Mermas archivadas para revisión..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveHologramas("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección V</span>
        </button>
      </div>
    </div>
  );
};

export default ControlHologramasSection;
